import { useEffect, useRef, useState } from "react";

export const useIsSizeMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const prevIsMobile = useRef(isMobile);

  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth <= 768;

      // Chỉ cập nhật state nếu giá trị thay đổi
      if (prevIsMobile.current !== newIsMobile) {
        prevIsMobile.current = newIsMobile;
        setIsMobile(newIsMobile);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
};
